import { useCallback, useState } from 'react';

/**
 * useToggle is like `useState()`, except it returns a function that will
 * toggle the value, instead of just setting it.
 */
export function useToggleState(
  defaultValue?: boolean | (() => boolean),
): [boolean, () => void, React.Dispatch<React.SetStateAction<boolean>>] {
  const [state, setState] = useState(defaultValue || false);

  const toggleValue = useCallback(() => setState((oldState) => !oldState), []);

  return [state, toggleValue, setState];
}
